import { posterSrc, formatDate } from "./api";

function loadImg(src) {
  return new Promise((res, rej) => { const i = new Image(); i.crossOrigin = "anonymous"; i.onload = () => res(i); i.onerror = rej; i.src = src; });
}

function wrap(ctx, text, x, y, maxW, lh) {
  const words = text.split(" "); let line = ""; let lines = 0;
  for (const w of words) {
    const t = line ? `${line} ${w}` : w;
    if (ctx.measureText(t).width > maxW && line) { ctx.fillText(line, x, y); y += lh; line = w; lines++; if (lines === 3) return y; }
    else line = t;
  }
  ctx.fillText(line, x, y); return y + lh;
}

export async function renderShareCard(b) {
  const W = 1080, H = 1920;
  const c = document.createElement("canvas"); c.width = W; c.height = H;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#2B0B15"; ctx.fillRect(0, 0, W, H);
  try {
    const img = await loadImg(posterSrc(b.event_poster_url));
    const s = Math.max(W / img.width, 1300 / img.height);
    ctx.drawImage(img, (W - img.width * s) / 2, 0, img.width * s, img.height * s);
  } catch { /* no poster */ }
  const g = ctx.createLinearGradient(0, 500, 0, 1400); g.addColorStop(0, "rgba(11,10,16,0)"); g.addColorStop(1, "#2B0B15");
  ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);

  ctx.fillStyle = "#C94A6A"; ctx.beginPath(); ctx.roundRect(72, 1180, 330, 56, 28); ctx.fill();
  ctx.fillStyle = "#fff"; ctx.font = "bold 24px 'JetBrains Mono', monospace"; ctx.fillText("I'M GOING  ✦", 100, 1218);

  ctx.fillStyle = "#FAFAFA"; ctx.font = "800 88px 'Syne', sans-serif";
  const y = wrap(ctx, b.event_title, 72, 1330, 940, 96);
  ctx.fillStyle = "#F2C7D2"; ctx.font = "600 38px 'Space Grotesk', sans-serif";
  ctx.fillText(formatDate(b.event_date), 72, y + 20);
  ctx.fillStyle = "#D4D4D8"; ctx.fillText(b.event_venue, 72, y + 74);
  if (b.seats?.length) { ctx.fillStyle = "#FF6AA6"; ctx.font = "500 32px 'JetBrains Mono', monospace"; ctx.fillText(`Seats ${b.seats.join(" · ")}`, 72, y + 128); }

  ctx.fillStyle = "#F2C7D2"; ctx.font = "800 54px 'Syne', sans-serif"; ctx.fillText("after", 72, 1800);
  const w = ctx.measureText("after").width;
  ctx.fillStyle = "#C94A6A"; ctx.fillText("hours.", 72 + w, 1800);
  ctx.fillStyle = "#71717A"; ctx.font = "500 26px 'JetBrains Mono', monospace"; ctx.textAlign = "right"; ctx.fillText("GET YOURS → " + window.location.host, W - 72, 1800); ctx.textAlign = "left";
  return new Promise((res) => c.toBlob(res, "image/png"));
}

export async function shareCard(b) {
  const blob = await renderShareCard(b);
  const file = new File([blob], `${b.booking_code}-story.png`, { type: "image/png" });
  const url = `${window.location.origin}/events/${b.event_id}`;
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    await navigator.share({ files: [file], title: b.event_title, text: `I'm going to ${b.event_title} — see you afterhours.`, url });
    return "shared";
  }
  const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = file.name; a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 5000);
  return "downloaded";
}
